import { render, staticRenderFns } from "./ModalHistorico.vue?vue&type=template&id=0be36943&scoped=true"
import script from "./ModalHistorico.vue?vue&type=script&lang=js"
export * from "./ModalHistorico.vue?vue&type=script&lang=js"
import style0 from "./ModalHistorico.vue?vue&type=style&index=0&id=0be36943&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be36943",
  null
  
)

export default component.exports